import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import SidePage from '@/shared/SidePage'
import { useState } from 'react'
import EquipmentSidePageViewContent from '@/pages/Equipment/components/SidePages/EquipmentSidePage/EquipmentSidePageViewContent'
import useEquipmentPassport from '@/pages/Equipment/hooks/useEquipmentPassport.ts'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import EquipmentSidePageEditContent from './EquipmentSidePageEditContent'

interface IProps {
  equipment: IEquipment
  open: boolean
  onClose: () => void
  onCloseAnimationEnd?: () => void
}

const EquipmentSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')
  const { passport: passportInstance } = useEquipmentPassport(props.equipment.passportInstanceId)

  const renderContent = () => {
    if (pageMode === 'edit') {
      if (props.equipment.passportInstanceId && !passportInstance) {
        return (
          <div className="flex-lines center" style={{ marginTop: '100px' }}>
            <ThreeDotsLoader inscription="Загружаем пасспорт..." />
          </div>
        )
      }

      return (
        <EquipmentSidePageEditContent
          passport={passportInstance}
          equipment={props.equipment}
          onCancel={() => setPageMode('view')}
        />
      )
    }

    return (
      <EquipmentSidePageViewContent
        equipment={props.equipment}
        passport={passportInstance}
        onClose={props.onClose}
        onEdit={() => setPageMode('edit')}
      />
    )
  }

  return (
    <SidePage
      onClose={props.onClose}
      open={props.open}
      size="large"
      style={{ paddingBottom: 0, paddingRight: 0 }}
      onCloseAnimationEnd={props.onCloseAnimationEnd}
    >
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.equipment) return null

  return <EquipmentSidePage {...props} />
}
